// Open external URL safely.
//
// Inside an iframe (e.g. Emergent's preview), many sites (LinkedIn, banks)
// refuse to load — and aggressively navigating the top window has poor UX.
//
// Strategy:
//   1. Try window.open(url, '_blank') — works in normal browsers.
//   2. If popup blocked AND we're inside an iframe, leave the click alone
//      (don't navigate the whole browser tab away). Browsers will then
//      handle the normal target="_blank" behaviour or show a popup prompt.
export function openExternalLink(e, url) {
  const target = url || e.currentTarget?.href;
  if (!target) return;
  try {
    const win = window.open(target, "_blank", "noopener,noreferrer");
    if (win && !win.closed) {
      e.preventDefault();
      return;
    }
  } catch {
    /* fall through to default browser behaviour */
  }
  // Let the browser's normal target="_blank" handling take over.
}
